const panels = [
  {
    id: 1,
    src: "https://storage.readdy-site.link/project_files/dc4c50b0-d993-4d24-8283-eb0f91b54b0d/f0b25e12-f2da-44a6-9a71-2d8ee97ff319_02_panel1.png?v=486fedeec12039e5d8bcfac9a38472ac",
    alt: "UTM導入前：社内PCがウイルス感染する場面",
    label: "BEFORE",
  },
  {
    id: 2,
    src: "https://storage.readdy-site.link/project_files/dc4c50b0-d993-4d24-8283-eb0f91b54b0d/e94e54da-d4d8-4257-8782-024fa964cf4e_03_panel2.png?v=27e0a08f87fc6d6cfb642e3f06c8f7a3",
    alt: "UTM導入の提案シーン",
    label: "PROPOSAL",
  },
  {
    id: 3,
    src: "https://storage.readdy-site.link/project_files/dc4c50b0-d993-4d24-8283-eb0f91b54b0d/d7594957-c738-436a-8ad8-e4b9182466dc_04_panel3.png?v=594bdab91f2e4d96731ea1c06518c06f",
    alt: "UTM導入・設定作業のシーン",
    label: "SETUP",
  },
  {
    id: 4,
    src: "https://storage.readdy-site.link/project_files/dc4c50b0-d993-4d24-8283-eb0f91b54b0d/1d67874f-3ea3-463d-8e90-76e290960417_05_panel4.png?v=92d57606ee8ffdfdbd95f319e6956270",
    alt: "UTM導入後：安心して業務できる場面",
    label: "AFTER",
  },
];

const MangaSection: React.FC = () => {
  return (
    <section className="bg-gradient-to-b from-white to-sky-50 py-20 px-6">
      <div className="max-w-6xl mx-auto">

        {/* ヘッダーエリア */}
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest text-sky-600 uppercase bg-sky-100 px-4 py-1.5 rounded-full mb-4">
            Story
          </span>
          <h2 className="text-3xl font-bold text-slate-800 tracking-tight mb-4">
            UTM導入で変わる日常
          </h2>
          <div className="w-16 h-0.5 bg-sky-400 mx-auto mb-4" />
          <p className="text-slate-500 text-sm max-w-xl mx-auto leading-relaxed">
            中小企業の現場でよくあるシーンを4コマでご紹介。
            UTM導入前後のリアルな変化をご覧ください。
          </p>
        </div>

        {/* 4コマパネル */}
        <div className="grid grid-cols-4 gap-5">
          {panels.map((panel) => (
            <div
              key={panel.id}
              className="flex flex-col items-center group"
            >
              {/* コマ番号バッジ */}
              <div className="flex items-center gap-2 mb-3 self-start">
                <div className="w-7 h-7 rounded-full bg-sky-600 text-white text-xs font-bold flex items-center justify-center flex-shrink-0">
                  {panel.id}
                </div>
                <span className="text-[10px] font-bold tracking-widest text-sky-600 uppercase">
                  {panel.label}
                </span>
              </div>

              {/* パネル画像 */}
              <div className="w-full rounded-xl overflow-hidden border border-sky-100 bg-white shadow-sm transition-transform duration-300 group-hover:-translate-y-1">
                <img
                  src={panel.src}
                  alt={panel.alt}
                  className="w-full h-auto object-top block"
                  loading="lazy"
                  title={panel.alt}
                />
              </div>
            </div>
          ))}
        </div>

        {/* 仕切り矢印 — コマ間の流れを示す装飾 */}
        <div className="flex justify-center gap-0 mt-6 select-none pointer-events-none">
          {[1, 2, 3].map((n) => (
            <span key={n} className="flex items-center gap-1 px-6">
              <span className="block w-12 h-0.5 bg-sky-200" />
              <span className="border-r-2 border-t-2 border-sky-300 w-2 h-2 rotate-45 -ml-1" />
            </span>
          ))}
        </div>

        {/* フッターキャプション */}
        <p className="text-center text-xs text-slate-400 mt-8">
          ※ 登場するキャラクター・企業名はすべて架空のものです
        </p>
      </div>
    </section>
  );
};

export default MangaSection;
